import StationaryTesting from "../../pages/StationaryTesting";
import NewStationaryRequest from "../../pages/StationaryTesting/components/NewRequest.jsx";
import ProcessRequest from "../../pages/StationaryTesting/components/ProcessRequest";
import { InternalUserRoles } from "../../constants/roles";
import { ReactComponent as StationaryTestingIcon } from "../../assets/stationarytestingicon.svg";
import { ModuleRouteConfig, RouteConfig } from "../types";

export const BASE_PATH = "/stationarytesting";

export const baseRoute: ModuleRouteConfig = {
  path: BASE_PATH,
  component: StationaryTesting,
  allowedRoles: InternalUserRoles,
  label: "Stationary Testing",
  icon: () => <StationaryTestingIcon />,
  isCustomIcon: true,
  hasDivider: false,
};

export const stationaryTestingRoutes: { [key: string]: RouteConfig } = {
  stationaryTesting: baseRoute,
  newStationaryRequest: {
    path: "/newStationaryRequest",
    component: NewStationaryRequest,
    allowedRoles: InternalUserRoles,
  },
  processRequest: {
    path: "/processRequest",
    component: ProcessRequest,
    allowedRoles: InternalUserRoles,
  },
};
